import React from 'react';
import { teaching_title, semester_title } from 'components/langutils';
import { useData } from '../Data';

export function BreadCrumb() {
  const { lang, type, current, semesters } = useData();
  const [current_semester, current_course] = current ?? [null, null];
  const semester = Object.values(semesters.courses).find((s: any) => s.id == current_semester) ?? {"name": ""} as any;
  const course = type?.courses.find((c: any) => c.id == current_course) ?? null;
  return (
    <React.Fragment>
      <a href="#">{teaching_title(lang)}</a> 
      <span className="site-breadcrumb__chevron" aria-hidden="true" />
      <a href={`#${encodeURI(current_semester)}`}>{ semester && semester?.name }</a>
      {course && <><span className="site-breadcrumb__chevron" aria-hidden="true" /> { course.name }</>}
    </React.Fragment>
  );
}
